<template>
    <!-- 我的钱包（PC） -->
    <ZhaiHeadPC class="zhai-head" />

    <div class="container errong">
        <!-- 顶部栏 -->
        <div class="container-fluid mt-3">
            <div class="row shengse mt-2">
                <div class="dixian px-3 py-2 top-bar-pc">
                    <div class="left lf" @click="goBack">
                        <i class="fa fa-bullhorn"></i> 推广中心
                    </div>
                </div>
            </div>
        </div>

        <!-- 主体 -->
        <div class="wallet-body-pc">
            <div class="wallet-shell-pc">

                <!-- ✅ 新增：主体页头（与其它页面同位置） -->
                <div class="page-head">
                    <div class="ph-left">
                        <div class="ph-title">我的钱包</div>
                        <div class="ph-sub">查看余额、提现及账户相关操作</div>
                    </div>

                </div>

                <div class="wallet-grid">
                    <!-- 左栏：余额卡 + 操作 -->
                    <div class="col-left">
                        <!-- 余额卡 -->
                        <div class="card card-balance">
                            <div class="balance-title">余额（元）</div>
                            <div class="balance-money">{{ todayIncome }}</div>

                            <div class="balance-actions">
                                <button class="btn-primary" @click="withdrawNow">申请提现</button>
                                <button class="btn-ghost" @click="goBack">返回推广中心</button>
                            </div>
                        </div>

                        <!-- 快捷入口（PC风格列表） -->
                        <div class="card card-list">
                            <div class="list-title">常用功能</div>

                            <div class="pc-list">
                                <div class="pc-item" @click="toBalanceDetail">
                                    <div class="pc-item-left">
                                        <span class="pc-ico"><i class="fa fa-file-text-o"></i></span>
                                        <span class="pc-text">余额明细</span>
                                    </div>
                                    <span class="pc-right">
                    查看 <i class="fa fa-angle-right"></i>
                  </span>
                                </div>

                                <div class="pc-item" @click="toWithdrawDetail">
                                    <div class="pc-item-left">
                                        <span class="pc-ico"><i class="fa fa-th-large"></i></span>
                                        <span class="pc-text">提现明细</span>
                                    </div>
                                    <span class="pc-right">
                    查看 <i class="fa fa-angle-right"></i>
                  </span>
                                </div>

                                <div class="pc-item" @click="toSetting">
                                    <div class="pc-item-left">
                                        <span class="pc-ico"><i class="fa fa-cog"></i></span>
                                        <span class="pc-text">提现设置</span>
                                    </div>
                                    <span class="pc-right">
                    去设置 <i class="fa fa-angle-right"></i>
                  </span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- 右栏：信息提示 -->
                    <div class="col-right">
                        <div class="card card-side">
                            <div class="side-title">钱包信息</div>

                            <div class="side-kv">
                                <div class="kv-row">
                                    <div class="k">余额</div>
                                    <div class="v">{{ todayIncome }} 元</div>
                                </div>
                                <div class="kv-row">
                                    <div class="k">快捷操作</div>
                                    <div class="v">余额提现 / 明细查看</div>
                                </div>
                                <div class="kv-row">
                                    <div class="k">账户设置</div>
                                    <div class="v">提现账户/实名</div>
                                </div>
                            </div>

                            <div class="side-divider"></div>

                            <div class="side-tips">
                                <div class="tips-title">温馨提示</div>
                                <ul class="tips-list">
                                    <li>余额提现需先设置提现账户信息。</li>
                                    <li>如遇到账延迟，请先查看提现明细状态。</li>
                                    <li>信息变更后请重新提交保存。</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="gray-gap"></div>
            </div>
        </div>
    </div>

    <div class="gongxi2"></div>
    <ZhaiFootPC />
</template>

<script>
    import ZhaiHeadPC from "../componentspc/ZhaiHeadPC";
    import ZhaiFootPC from "../componentspc/ZhaiFootPC";
    import http from "@/utils/http";

    export default {
        name: "PPMyWallet",
        components: { ZhaiHeadPC, ZhaiFootPC },

        data() {
            return {
                // 页面展示余额（元，字符串保留两位）
                todayIncome: "0.00",

                // 更稳的 userId（同 Promotion / 提现明细）
                currentUserId: null,

                // 可选：加载/错误态（你模板没用也没关系）
                loading: false,
                error: "",
            };
        },

        // ✅ 路由守卫：未登录直接跳登录页（同 Promotion / 提现明细）
        beforeRouteEnter(to, from, next) {
            const token = localStorage.getItem("token");
            if (!token) next("/login");
            else next();
        },

        async mounted() {
            // ✅ mounted 再兜底一次（同 Promotion / 提现明细）
            const token = localStorage.getItem("token");
            if (!token) {
                if (this.$router) this.$router.replace("/login");
                else window.location.href = "/login";
                return;
            }

            // ✅ 更稳的 userId 获取
            this.currentUserId = this.resolveUserIdSafe();

            // ✅ 拉余额
            await this.fetchBalance();
        },

        methods: {
            // ================== 工具：更稳的 userId 获取（完全同风格） ==================
            resolveUserIdSafe() {
                // 1) localStorage 常见存法
                const tryKeys = ["user", "userinfo", "userInfo", "USER", "User"];
                for (const k of tryKeys) {
                    try {
                        const raw = localStorage.getItem(k);
                        if (!raw) continue;
                        const obj = JSON.parse(raw);
                        if (obj && obj.id) return obj.id;
                        if (obj && obj.data && obj.data.id) return obj.data.id;
                    } catch (e) {
                        // ignore
                    }
                }

                // 2) 拿不到就返回 null（让后端 token 解析兜底）
                return null;
            },

            // ================== 工具：分转元（保留两位） ==================
            centToYuanString(cent) {
                const v = Number(cent);
                if (!Number.isFinite(v)) return "0.00";
                return (v / 100).toFixed(2);
            },

            // ================== 拉余额（匹配后端：/platform/withdraw/balance） ==================
            async fetchBalance() {
                if (this.loading) return;
                this.loading = true;
                this.error = "";

                try {
                    // ✅ 参数匹配后端：userId 可传可不传
                    const params = this.currentUserId ? { userId: this.currentUserId } : null;

                    const res = await http.get("/platform/withdraw/balance", params);
                    const json = res && res.data ? res.data : null;

                    if (!json || Number(json.status) !== 1) {
                        const msg = (json && json.msg) || "获取余额失败";

                        // ✅ 未登录：直接跳登录（同提现明细）
                        if (msg.includes("未登录") || msg.includes("登录")) {
                            if (this.$router) this.$router.replace("/login");
                            else window.location.href = "/login";
                            return;
                        }

                        throw new Error(msg);
                    }

                    const data = json.data || {};

                    // ✅ 兼容两种字段：balanceCent / availableCent
                    const cent =
                        typeof data.balanceCent !== "undefined"
                            ? data.balanceCent
                            : typeof data.availableCent !== "undefined"
                            ? data.availableCent
                            : 0;

                    this.todayIncome = this.centToYuanString(cent);
                } catch (e) {
                    console.error(e);
                    this.error = e && e.message ? e.message : "网络异常，请稍后再试";
                    // 页面上你没展示 error，这里也可以不做 UI
                    this.todayIncome = "0.00";
                } finally {
                    this.loading = false;
                }
            },

            // ================== 跳转（保持你原来的） ==================
            goBack() {
                if (this.$router) this.$router.push("/Promotion");
                else window.location.href = "/Promotion";
            },

            toBalanceDetail() {
                if (this.$router) this.$router.push("/BalanceDetails");
                else window.location.href = "/BalanceDetails";
            },

            toWithdrawDetail() {
                if (this.$router) this.$router.push("/WithdrawalDetails");
                else window.location.href = "/WithdrawalDetails";
            },

            toSetting() {
                if (this.$router) this.$router.push("/WalletSettings");
                else window.location.href = "/WalletSettings";
            },

            withdrawNow() {
                if (this.$router) this.$router.push("/WalletWithdrawal");
                else window.location.href = "/WalletWithdrawal";
            },
        },
    };
</script>


<style scoped>
    /* 基础 */
    body {
        font-family: Arial, sans-serif;
    }
    /* ✅ 页头（与其它钱包页面保持一致） */
    .page-head {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 12px;
        padding: 14px 14px;
        background: #fff;
        border: 1px solid #eee;
        border-radius: 2px;
        margin-bottom: 10px;
    }
    .ph-left { min-width: 0; }
    .ph-title { font-size: 16px; font-weight: 900; color: #111; }
    .ph-sub { margin-top: 6px; font-size: 13px; color: #888; }
    .ph-right { display: flex; gap: 10px; flex-wrap: wrap; }

    .btn-soft {
        height: 36px;
        padding: 0 12px;
        border-radius: 2px;
        border: 1px solid #eee;
        background: #fafafa;
        font-size: 13px;
        cursor: pointer;
        color: #333;
        display: inline-flex;
        align-items: center;
    }
    .btn-soft .fa { margin-right: 8px; color: #00c26f; }
    .btn-soft:active { opacity: 0.8; }

    .fa {
        margin-right: 6px;
    }
    .lf {
        font-weight: 900;
    }
    .gongxi2 {
        height: 20px;
    }
    .errong {
        padding-left: 30px;
        padding-right: 30px;
    }

    @media (min-width: 768px) {
        .zhai-head {
            position: fixed;
            top: 0;
            width: 100%;
            z-index: 1000;
        }
        .errong {
            margin-top: 80px;
        }
    }

    /* 顶部栏（PC） */
    .top-bar-pc {
        display: grid;
        grid-template-columns: 1fr auto 1fr;
        align-items: center;
    }
    .top-bar-pc .left {
        cursor: pointer;
        color: #333;
        font-size: 15px;
        display: inline-flex;
        align-items: center;
    }
    .top-bar-pc .left:active {
        opacity: 0.75;
    }
    .top-bar-pc .center {
        justify-self: center;
        font-size: 16px;
        font-weight: 900;
        color: #00c26f;
    }
    .top-bar-pc .right {
        justify-self: end;
        cursor: pointer;
        color: #00c26f;
        font-size: 14px;
        display: inline-flex;
        align-items: center;
    }
    .arrow {
        margin-left: 6px;
        font-size: 18px;
        color: #aaa;
    }

    /* 主体背景（左右栏外壳） */
    .wallet-body-pc {
        background: #efefef;
        border-radius: 2px; /* ✅ 2px */
        margin-top: 10px;
    }
    .wallet-shell-pc {
        max-width: 1200px;
        margin: 0 auto;
    }

    /* 两栏布局 */
    .wallet-grid {
        display: grid;
        grid-template-columns: 1.6fr 1fr;
        gap: 16px;
    }
    @media (max-width: 992px) {
        .wallet-grid {
            grid-template-columns: 1fr;
        }
    }

    /* 卡片（统一 2px） */
    .card {
        background: #fff;
        border-radius: 2px; /* ✅ 2px */
        box-shadow: 0 10px 26px rgba(0, 0, 0, 0.06);
        padding: 16px;
    }
    .card + .card {
        margin-top: 12px;
    }

    /* 余额卡 */
    .card-balance {
        padding: 20px 18px;
    }
    .balance-title {
        font-size: 13px;
        color: #888;
        margin-bottom: 10px;
    }
    .balance-money {
        font-size: 44px;
        font-weight: 900;
        color: #111;
        line-height: 1.05;
    }
    .balance-actions {
        margin-top: 16px;
        display: flex;
        gap: 10px;
        flex-wrap: wrap;
    }

    /* 按钮（全部 2px） */
    .btn-primary {
        height: 40px;
        padding: 0 14px;
        border-radius: 2px; /* ✅ 2px */
        border: none;
        cursor: pointer;
        font-size: 14px;
        font-weight: 900;
        color: #fff;
        background: linear-gradient(90deg, #ff4d4f, #ff7a6a);
        box-shadow: 0 6px 16px rgba(255, 77, 79, 0.18);
    }
    .btn-primary:active {
        opacity: 0.9;
    }

    .btn-ghost {
        height: 40px;
        padding: 0 14px;
        border-radius: 2px; /* ✅ 2px */
        border: 1px solid #ffe2e2;
        background: #fff0f0;
        cursor: pointer;
        font-size: 14px;
        font-weight: 800;
        color: #ff4d4f;
    }
    .btn-ghost:active {
        opacity: 0.85;
    }

    /* 列表卡 */
    .list-title {
        font-size: 15px;
        font-weight: 900;
        color: #111;
        margin-bottom: 10px;
    }

    .pc-list {
        border: 1px solid #f2f2f2;
        border-radius: 2px; /* ✅ 2px */
        overflow: hidden;
    }
    .pc-item {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 14px 14px;
        border-bottom: 1px solid #f6f6f6;
        cursor: pointer;
        background: #fff;
    }
    .pc-item:last-child {
        border-bottom: 0;
    }
    .pc-item:hover {
        background: #fafafa;
    }
    .pc-item-left {
        display: flex;
        align-items: center;
        gap: 12px;
        min-width: 0;
    }
    .pc-text {
        font-size: 14px;
        font-weight: 800;
        color: #111;
    }
    .pc-right {
        font-size: 13px;
        color: #2f6fed;
        display: inline-flex;
        align-items: center;
        gap: 6px;
    }
    .pc-right .fa {
        margin-right: 0;
        font-size: 18px;
        color: #c7c7c7;
    }

    /* 左侧图标块 */
    .pc-ico {
        width: 34px;
        height: 34px;
        border-radius: 2px; /* ✅ 2px（图标底块也统一） */
        display: flex;
        align-items: center;
        justify-content: center;
        background: rgba(255, 77, 79, 0.08);
        flex: 0 0 auto;
    }
    .pc-ico .fa {
        margin-right: 0;
        font-size: 16px;
        color: #ff4d4f;
    }

    /* 右侧信息卡 */
    .card-side .side-title {
        font-size: 15px;
        font-weight: 900;
        color: #111;
        margin-bottom: 10px;
    }
    .side-kv {
        border: 1px solid #f2f2f2;
        border-radius: 2px; /* ✅ 2px */
        padding: 10px 12px;
        background: #fff;
    }
    .kv-row {
        display: flex;
        justify-content: space-between;
        gap: 12px;
        padding: 8px 0;
        border-bottom: 1px dashed #f0f0f0;
    }
    .kv-row:last-child {
        border-bottom: 0;
    }
    .kv-row .k {
        font-size: 13px;
        color: #777;
    }
    .kv-row .v {
        font-size: 13px;
        color: #111;
        font-weight: 700;
        text-align: right;
    }
    .side-divider {
        height: 1px;
        background: #f2f2f2;
        margin: 14px 0;
    }
    .tips-title {
        font-size: 13px;
        font-weight: 900;
        color: #111;
        margin-bottom: 8px;
    }
    .tips-list {
        margin: 0;
        padding-left: 18px;
        color: #777;
        font-size: 13px;
        line-height: 1.8;
    }
    .side-actions {
        margin-top: 14px;
        display: flex;
        gap: 10px;
        flex-wrap: wrap;
        justify-content: flex-start;
    }
    .btn-outline {
        height: 36px;
        padding: 0 12px;
        border-radius: 2px; /* ✅ 2px */
        border: 1px solid #e9e9e9;
        background: #fff;
        font-size: 13px;
        cursor: pointer;
    }
    .btn-outline:active {
        opacity: 0.75;
    }

    .gray-gap {
        height: 18px;
    }
</style>
